export default __webpack_public_path__ + "static/media/gallery_20.c922d3e8.jpg";